import sectionCardVitalSlider02Css from '../css-snippets/section-card-vital-slider-02';

const html = `
<style>${sectionCardVitalSlider02Css}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #ffffff; color: #000000; --color-text: #000000; --color-background: #ffffff; --item-content-background: #daecf0; --item-content-background-hover: #214a88; --item-content-text-color: #214a88; --item-content-text-color-hover: #ffffff; ">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-show-title="true" data-attribute="title-card" class="title-card">
          <h2 style="text-align: center;">Lorem ipsum dolor</h2>
        </div>
        <div class="wrap-content">
          <div class="swiper swiper-vital-unique-id">
            <div data-col-per-view="3" data-space-between="44" data-item-background="#ffffff"
              data-item-content-background="#daecf0" data-item-content-background-hover="#214a88"
              data-item-content-text-color="#214a88" data-item-content-text-color-hover="#ffffff"
              data-attribute="list-item" class="swiper-wrapper">

              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img-decor">
                    <img data-attribute="img-decor-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69ce29651c376359a9723fa0.jpg" alt="">
                  </div>
                  <div data-attribute="content-item" class="content-item">
                    <div data-attribute="title-item" class="title-item">
                      <h2>Collagen Peptides</h2>
                      <p>15,000mg</p>
                    </div>
                    <div data-attribute="description-item" class="description-item">
                      <p>Collagen Peptides are a type of protein that is found in the body. They are made up of amino
                        acids that are linked together to form a chain. Collagen Peptides are found in the body in the
                        form of collagen fibers.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img-decor">
                    <img data-attribute="img-decor-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69ce296c76080245ced087a8.webp" alt="">
                  </div>
                  <div data-attribute="content-item" class="content-item">
                    <div data-attribute="title-item" class="title-item">
                      <h2>Collagen Peptides</h2>
                      <p>15,000mg</p>
                    </div>
                    <div data-attribute="description-item" class="description-item">
                      <p>Collagen Peptides are a type of protein that is found in the body. They are made up of amino
                        acids that are linked together to form a chain. Collagen Peptides are found in the body in the
                        form of collagen fibers.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img-decor">
                    <img data-attribute="img-decor-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69ce2986553c3ecd26d84169.webp" alt="">
                  </div>
                  <div data-attribute="content-item" class="content-item">
                    <div data-attribute="title-item" class="title-item">
                      <h2>Collagen Peptides</h2>
                      <p>15,000mg</p>
                    </div>
                    <div data-attribute="description-item" class="description-item">
                      <p>Collagen Peptides are a type of protein that is found in the body. They are made up of amino
                        acids that are linked together to form a chain. Collagen Peptides are found in the body in the
                        form of collagen fibers.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img-decor">
                    <img data-attribute="img-decor-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69ce2986553c3ecd26d84169.webp" alt="">
                  </div>
                  <div data-attribute="content-item" class="content-item">
                    <div data-attribute="title-item" class="title-item">
                      <h2>Collagen Peptides</h2>
                      <p>15,000mg</p>
                    </div>
                    <div data-attribute="description-item" class="description-item">
                      <h2>Lorem ipsum dolor,</h2>
                      <p>Collagen Peptides are a type of protein that is found in the body. They are made up of amino
                        acids that are linked together to form a chain. Collagen Peptides are found in the body in the
                        form of collagen fibers.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
